'use strict';

class PositionTypeListCtrl {
  constructor($stateParams, $location, LoaderSvc, PositionTypeSvc,
    GroupAuthSvc) {
    LoaderSvc.start('Loading Position Types...');
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId; // set for group urls
    var groupId = $stateParams.groupId;
    this.groupId = Number(groupId); // convert to number for disable link check

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'positionType', 'I');

    // default filter
    if(Object.keys($location.search()).length === 0) {
      $location.search({isActive: 'true'}); // string required for url
    }

    that.dataModel = 'ptvm';
    PositionTypeSvc.getDefinedBy({groupId}).$promise
      .then(function(data) {
        that.data = data;
        that.order = 'name';
        that.searchField = 'name';
        LoaderSvc.stop();
      })
      .catch(function() {
        LoaderSvc.stopError('Error loading position types');
      });
  }
}

PositionTypeListCtrl.$inject = [
  '$stateParams',
  '$location',
  'LoaderSvc',
  'PositionTypeSvc',
  'GroupAuthSvc'
];

export default PositionTypeListCtrl;
